// src/components/Depoimentos.js
import React, { useState, useEffect } from "react";
import "./Depoimentos.css";

// 1. Estrutura de Dados: Facilita adicionar ou remover depoimentos.
const depoimentosList = [
  {
    quote:
      "Depois da consultoria, entendi que roupa não é só vaidade: é comunicação. Hoje, cada look que eu uso no trabalho transmite exatamente a imagem que quero passar. Me sinto mais confiante, alinhada e coerente com a minha área de atuação.",
    author: "Alessanda Baraviera",
    role: "Gerente Administrativa",
  },
  {
    quote:
      "A consultoria me ajudou a entender como adaptar meu estilo ao ambiente profissional, sem perder minha identidade. Aprendi sobre cores, cortes e combinações que favorecem minha rotina e objetivos. Foi um investimento que trouxe retorno rápido e visível.",
    author: "Wender Epifânio",
    role: "Publicitário",
  },
  {
    quote:
      "Eu não tinha ideia do poder que as cores certas tinham sobre minha imagem. A análise de coloração pessoal foi reveladora e hoje consigo fazer compras muito mais assertivas. Recomendo a Yvinna de olhos fechados!",
    author: "Juliana Costa",
    role: "Arquiteta",
  },
];

const Depoimentos = () => {
  // 2. State para controlar o índice do depoimento atual
  const [currentIndex, setCurrentIndex] = useState(0);

  // 3. useEffect para automatizar a troca de depoimentos
  useEffect(() => {
    // Define um intervalo para trocar de slide a cada 8 segundos (8000 ms)
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % depoimentosList.length);
    }, 8000);

    // Função de limpeza: remove o intervalo quando o componente é desmontado
    return () => clearInterval(intervalId);
  }, []); // O array vazio [] garante que o efeito rode apenas uma vez (na montagem)

  return (
    <section id="depoimentos" className="depoimentos-section">
      <div className="container">
        <div className="quote-wrapper">
          <span className="quote-icon">“</span>

          {/* 4. Mapeia a lista de depoimentos para criar os slides */}
          {depoimentosList.map((depoimento, index) => (
            <div
              key={index}
              className={`testimonial-slide ${
                index === currentIndex ? "active" : ""
              }`}
            >
              <p className="quote-text">{depoimento.quote}</p>
              <p className="quote-author">
                – {depoimento.author} <span>{depoimento.role}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Depoimentos;
